export const ASK_PROVIDER_STORAGE_KEY = 'hashely_canvas_ask_provider';
export const ASK_PROVIDER_CHANGE_EVENT = 'hashely:ask-provider-change';

export const ASK_PROVIDER_OPTIONS = [
  { id: 'gemini', label: 'Gemini' },
  { id: 'gpt', label: 'GPT' },
  { id: 'claude', label: 'Claude' },
  { id: 'perplexity', label: 'Perplexity' },
];

export const DEFAULT_ASK_PROVIDER = 'gemini';

export function isValidAskProvider(provider) {
  return ASK_PROVIDER_OPTIONS.some(option => option.id === provider);
}

export function normalizeAskProvider(provider) {
  const input = String(provider || '').trim().toLowerCase();
  if (isValidAskProvider(input)) return input;
  return DEFAULT_ASK_PROVIDER;
}

export function readAskProvider() {
  try {
    return normalizeAskProvider(window.localStorage?.getItem(ASK_PROVIDER_STORAGE_KEY));
  } catch {
    return DEFAULT_ASK_PROVIDER;
  }
}

export function writeAskProvider(provider) {
  const normalized = normalizeAskProvider(provider);
  try {
    window.localStorage?.setItem(ASK_PROVIDER_STORAGE_KEY, normalized);
  } catch {
    // ignore storage errors
  }
  return normalized;
}

export function dispatchAskProviderChange(provider) {
  try {
    window.dispatchEvent(
      new CustomEvent(ASK_PROVIDER_CHANGE_EVENT, {
        detail: { provider: normalizeAskProvider(provider) },
      })
    );
  } catch {
    // ignore
  }
}

export function askProviderLabel(provider) {
  const id = normalizeAskProvider(provider);
  return ASK_PROVIDER_OPTIONS.find(option => option.id === id)?.label || 'Gemini';
}
